import * as types from './mutation-types';

export const addToCart = ({ commit }, item) => {
  commit(types.ADD_TO_CART, item);
};

export const removeFromCart = ({ commit }, item) => {
  commit(types.REMOVE_FROM_CART, item);
};

export const updateTotals = ({ commit }, totals) => {
  commit(types.UPDATE_TOTALS, totals);
};
